import { forwardRef, RefObject } from "react";
import { Icon } from "@newsela/angelou";

import DefaultNoImageIcon from "./DefaultNoImageIcon.svg.jsx";

const NoImageIcon = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref as RefObject<SVGSVGElement>}
      SvgComponent={DefaultNoImageIcon}
      {...props}
    />
  );
});

export default NoImageIcon;
